import * as Yup from "yup";
import i18next from "i18next";

const NAME_RE = /^[\p{L}]+(?:[\s.'’-]+[\p{L}]+)*\.?$/u
const MOBILE_RE = /^\d{10}$/
const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/

const parseDate = (value) => {
    if (value == null || value === '') return null
    if (typeof value === 'object' && typeof value.isValid === 'function' && typeof value.format === 'function') {
        return value.isValid() ? parseDate(value.format('DD/MM/YYYY')) : null
    }
    const text = String(value).trim()
    const dmy = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(text)
    const ymd = /^(\d{4})-(\d{2})-(\d{2})/.exec(text)
    const day = dmy ? Number(dmy[1]) : ymd ? Number(ymd[3]) : NaN
    const month = dmy ? Number(dmy[2]) : ymd ? Number(ymd[2]) : NaN
    const year = dmy ? Number(dmy[3]) : ymd ? Number(ymd[1]) : NaN
    if (!year || month < 1 || month > 12 || day < 1) return null
    const date = new Date(year, month - 1, day)
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null
    date.setHours(0, 0, 0, 0)
    return date
}

const personName = (message) => Yup.string().trim().required(message).min(2, message).max(100, message).matches(NAME_RE, message)

export const UpdateProfileSchema = () => Yup.object({
    first_name: personName(i18next.t('profile.error_fname')),
    last_name: personName(i18next.t('profile.error_lname')),
    gender: Yup.string().trim().required(i18next.t('profile.error_gender')).matches(/^(male|female)$/i, i18next.t('profile.error_gender')),
    dob: Yup.mixed()
        .required(i18next.t('profile.error_dob'))
        .test('dob-format', i18next.t('profile.error_dob'), (value) => !!parseDate(value))
        .test('dob-not-future', i18next.t('profile.error_dob'), (value) => {
            const selected = parseDate(value)
            if (!selected) return true
            const today = new Date()
            today.setHours(0, 0, 0, 0)
            return selected <= today && selected.getFullYear() >= 1900
        }),
    email: Yup.string().trim().required(i18next.t('profile.error_email')).max(100).email(i18next.t('profile.error_email')).matches(EMAIL_RE, i18next.t('profile.error_email')),
    mobile_number: Yup.string().trim().required(i18next.t('profile.error_mobile')).matches(MOBILE_RE, i18next.t('profile.error_invalid_mobile')),
    profile: Yup.mixed().notRequired().test('image-type', i18next.t('profile.error_profile'), (value) => !value || typeof value === 'string' || String(value.type || '').startsWith('image/')),
    district: Yup.string().trim().required(i18next.t('profile.error_district')),
    address: Yup.string().trim().required(i18next.t('profile.error_address')).min(3, i18next.t('profile.error_address')).max(500, i18next.t('profile.error_address')).matches(/[\p{L}0-9]/u, i18next.t('profile.error_address')),
});
